import { dialog } from "../../../../../nq-component";
import BaseListPresenter from "../../../../../base/BaseListPresenter";
import toast from "react-hot-toast";

class CreditInActiveListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  init() {
    this.limit = 20;
    this.where = {
      status: "Inactive",
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects() {
    this.showProgress();
    this.reset();
    await this.countObjects();
    await this.findObjects();
    await this.findClient();
    this.hideProgress();
  }

  //   async findObjects() {
  //     const collection = this.view.getCollectionName();
  //     const query = this.createQuery();
  //     const mergedObjects = [];

  //     try {
  //       this.findObjectUseCase.abort();
  //       const objects = await this.findObjectUseCase.execute(collection, query);

  //       // GET CLIENT CREDITS
  //       for (const object of objects) {
  //         console.log("loop", object);
  //         const creditObject = await this.findObjectUseCase.execute(
  //           "search_logs",
  //           {
  //             where: { searcher: { affiliate: { id: object.code } } },
  //           }
  //         );

  //         mergedObjects.push({ ...object, credit: creditObject?.length || 0 });
  //       }

  //       this.objects = this.objects.concat(mergedObjects);
  //       this.view.setTotal(this.objects.length);
  //       this.view.setObjects(this.objects);
  //     } catch (error) {
  //       this.view.showError(error);
  //     }
  //   }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
    } catch (error) {
      this.view.showError(error);
    }
  }

  async findClient() {
    const response = await this.findObjectUseCase.execute("affiliates");

    this.view.setClient(response);
  }

  onChange(value, field) {
    this.change = this.change || {};
    this.object = this.object || {};
    this.change[field] = value;
    this.object[field] = value;
  }

  async submitData() {
    const collection = this.view.getCollectionName();

    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }
    this.change.client = { id: this.change.client.id };

    delete this.change.amount;
    delete this.change.createdAt;

    // const sendLogs = this.change;

    // sendLogs.creditId = this.change.id;

    // delete sendLogs.id;

    const sendLogs = JSON.parse(JSON.stringify(this.change));
    sendLogs.creditId = this.change.id;
    sendLogs.created = this.change.createdAt;
    sendLogs.updated = this.change.updatedAt;
    // delete sendLogs.id;
    delete sendLogs.createdAt;
    delete sendLogs.updatedAt;
    delete sendLogs.status;

    try {
      await this.upsertUseCase.execute(collection, this.change);
      // await this.upsertUseCase.execute("credits_logs", sendLogs);
      this.change = {};
      this.view.setObjects(this.objects);
      this.reset();
      this.getObjects();

      toast.success("Successfully saved!", { position: "top-right" });
    } catch (error) {
      this.view.showError("Client is already exists.", "Error Client");
      throw error;
    }
  }

  async onClickInactive(object) {
    const collection = this.view.getCollectionName();

    object.status = "Active";
    try {
      await this.upsertUseCase.execute(collection, object);
      this.change = {};
      this.view.setObjects(this.objects);
      this.reset();
      this.getObjects();
    } catch (error) {}
  }

  //   async submitData() {
  //     const collection = this.view.getCollectionName();
  //     console.log("this", this.object);

  //     if (this.object.id) {
  //       this.change.id = this.object.id;
  //     } else {
  //       this.change.acl = this.view.getAcl();
  //     }

  //     this.change.client = { id: this.change.client.id };

  //     // Clean up for saving to main collection
  //     delete this.change.amount;

  //     console.log("send", this.change);

  //     // Clone the object before modifying for logs
  //     const sendLogs = JSON.parse(JSON.stringify(this.change));
  //     sendLogs.creditId = this.change.id;
  //     delete sendLogs.id;

  //     console.log("send logs", sendLogs);

  //     try {
  //       await this.upsertUseCase.execute(collection, this.change);
  //       await this.upsertUseCase.execute("credits_logs", sendLogs);

  //       this.change = {};
  //       this.view.setObjects(this.objects);
  //       this.reset();
  //       this.getObjects();

  //       toast.success("Successfully saved!", { position: "top-right" });
  //     } catch (error) {
  //       this.view.showError("Client already exists.", "Error Client");
  //     }
  //   }
}

export default CreditInActiveListPresenter;
